<template>
  <div class="footerS-wrap">
      <div style="height:4px"></div>
      <div class="footerS1">北京久其软件</div>
      <div class="footerS2">
        <div class="footer-items">
            <div class="footer-item1">客服热线：400-119-9797</div>
            <div class="footer-item2">ICP备案编号：京ICP备20009057号-1</div>
            <div class="footer-item3">邮箱：jiuqi@jiuqi.com.cn</div>
        </div>
      </div>
      <div class="footerS-bg">
          <div class="footerS-bg1"></div>
          <div class="footerS-bg2"></div>
      </div>
  </div>
</template>

<script>
export default {
  components:{
  }
}
</script>

<style lang="less" scoped>
.footerS-wrap{
    width: 100%;
    height: 91px;
    position: relative;
    background: #FCFCFC;
    box-shadow: 0 -1px 0 0 rgba(215,215,215,0.50);
    overflow: hidden;
    .footerS1{
        height: 20px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #686868;
        line-height: 20px;
        text-align: center;
        margin-bottom: 27px;
    }
    .footer-items{
        width: 710px;
        height: 28px;
        margin: 0 auto;
        position: absolute;
        z-index: 2;
        left: 50%;
        margin-left: -355px;
    }
    .footer-item1{
        float: left;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 28px;
        margin-right: 100px;
    }
    .footer-item2{
        float: left;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 28px;
        margin-right: 100px;
    }
    .footer-item3{
        float: left;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        color: #FFFFFF;
        line-height: 28px;
    }
    .footerS-bg{
        width: 100%;
        height: 60px;
        position:absolute;
        left: 230px;
        bottom: 0;
        z-index: 1;
        .footerS-bg1{
            float: left;
            width: 61px;
            height: 61px;
            background: url('../../static/img1/蓝色背景@2x.png');
            background-size: 61px 61px;
        }
        .footerS-bg2{
            float: left;
            height: 59px;
            width: calc(~"100% - 65px");
            background: #015293;
            margin-top: 1px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/footerS.vue